module.exports = __webpack_public_path__ + "img/payment link asset.4e44f34b.svg";